import { softwareStepsConfig, stepsConfig } from '../../constants';

export function getStepperLabels(starter_type) {
  return [
    { order: 1, id: stepsConfig.start_screen, name: stepsConfig.start_screen },
    { order: 2, id: stepsConfig.head_device_selector_screen, name: `${stepsConfig.head_device_selector_screen}.${starter_type}` },
    { order: 3, id: stepsConfig.configuration_editor_screen, name: stepsConfig.configuration_editor_screen },
    { order: 4, id: stepsConfig.power_supply, name: stepsConfig.power_supply },
    { order: 5, id: stepsConfig.accessorize, name: stepsConfig.accessorize },
    { order: 6, id: stepsConfig.save_screen, name: stepsConfig.save_screen }
  ];

}

export function getSoftwareStepperLabels() {
  return [
    { order: 1, id: softwareStepsConfig.software_selection, name: softwareStepsConfig.software_selection },
    { order: 2, id: softwareStepsConfig.licence_selector, name: softwareStepsConfig.licence_selector },
    { order: 3, id: softwareStepsConfig.service_plan, name: softwareStepsConfig.service_plan},
    { order: 4, id: stepsConfig.save_screen, name: stepsConfig.save_screen }
  ];
}
